// src/components/store/sections/blog-posts/BlogV103GridcardsSlateGold.tsx
"use client";

import React from "react";
import DynamicBlogVariant from "./DynamicBlogVariant";

export default function BlogV103GridcardsSlateGold(props: any) {
  return (
    <DynamicBlogVariant
      variantNumber={103}
      archKey="grid_cards"
      archLabel="Modern Card Grid"
      palName="SlateGold"
      grad="from-slate-800 via-zinc-900 to-neutral-950"
      lightBg="bg-amber-50/80"
      textCol="text-amber-700"
      borderCol="border-amber-300"
      btnCls="bg-slate-900 hover:bg-slate-800"
      hexCol="#eab308"
      {...props}
    />
  );
}
